import React, { useCallback, useEffect, useState, useMemo } from 'react';
import CustomBreadcrumbs from '../../Components/CommonComponents/CustomBreadcrumbs';
import CustomInput from '../../Components/CommonComponents/CustomInput';
import CustomButton from '../../Components/CommonComponents/CustomButton';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux';
import { UploadFiles, getJwtToken, getSinglePatientFetch, setClinicProfile } from '../../Redux/AdminReducer/action';
import { useNavigate, useParams } from 'react-router-dom';
import { UploadFile, END_POINT, RemoveFile, UploadImages, DeleteImages } from '../../Redux/AdminReducer/action';
import CustomSpinner from '../../Components/CommonComponents/CustomSpinner';
import { FileUploadModal, ImageShowModal, ImageUploadModal, MultipleFileUploads } from '../../Components/CommonComponents/DoctorUploadModals';
import CustomImageInput from '../../Components/CommonComponents/CustomImageInput';
import axios from 'axios';
import CustomSelect from '../../Components/CommonComponents/CustomSelect';
import SearchableSelect from '../../Components/CommonComponents/SearchableSelect';
import countiresData from '../../Files/countries.json';
import citiesData from '../../Files/cities.json';
import usePincodeLookup from '../../hooks/usePincodeLookup';
import { useLinkedDropdown, resolveChildSelection } from '../../Services/linkedDropdowns';
import statesData from '../../Files/states.json';
import { FaStar } from 'react-icons/fa';
import { FiCopy, FiSend, FiExternalLink } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import { getAllDropDowns } from '../../Redux/Store/API/DropDownApi';
import { getAllAilments } from '../../Redux/Store/API/SubAilments';
import RightWrapper from '../../Components/CommonComponents/ComponentWrapper';
import { getProfileCompletion, COMPLETION_FIELD_LABELS } from '../../Services/patientCompletion';

const fetchSingleItem = async (id) => {
  try {
    const result = await axios.get(`${END_POINT}/customer/${id}`, {
      headers: {
        Authorization: getJwtToken(),
      },
    });
    return result;
  } catch (error) {
    toast.error(error?.response?.data || 'Something went wrong');
    console.log(error);
  }
};

const createItem = async (data, navigate, setIsPorcessing) => {
  try {
    const result = await axios.post(`${END_POINT}/customer`, data, {
      headers: {
        Authorization: getJwtToken(),
      },
    });
    let { data: id } = result?.data;
    setIsPorcessing(false);
    navigate(`/patients`);
    toast.success('Patient Created Successfully');
  } catch (error) {
    toast.error(error?.response?.data || 'Something went wrong');
    setIsPorcessing(false);
  }
};

const updateItem = async (data, setIsPorcessing) => {
  try {
    const result = await axios.put(`${END_POINT}/customer/updateProfile/${data._id}`, data, {
      headers: {
        Authorization: getJwtToken(),
      },
    });
    toast.success('Details Updated');
    setTimeout(() => {
      window.location.reload();
    }, 500);
  } catch (error) {
    toast.error(error?.response?.data || 'Something went wrong');
    setIsPorcessing(false);
    toast.error('Failed To Updated');
  }
};

// Shown on every dropdown until the user picks something; nothing is preselected.
const SELECT_PLACEHOLDER = 'Choose the Right Option';
const NO_OPTIONS_HINT = 'No options configured — add in Drop Down settings';

// Drop Down settings list (key in the DropDown store) -> patient field it fills.
// The names differ (e.g. status_by_appointment is stored as status_by_visit) and
// the graphs read the stored names, so the pairing is spelled out here instead
// of renaming either side. Keep in step with PATIENT_FIELD_MAP in
// backend/Controllers/DropDownOptions.js.
export const PATIENT_DROPDOWN_FIELDS = {
  education: 'education',
  industry: 'industry',
  profession: 'profession',
  type_of_patient: 'Patient_Type',
  status_by_appointment: 'status_by_visit',
  status_by_treatment: 'status_by_treatment',
  reference_for_enquiry: 'reference',
  patient_reference: 'patientReference',
  mother_tongue: 'motherTongue',
  religion: 'religion',
  gender: 'gender',
  marital_status: 'maritalStatus',
  blood_group: 'bloodGroup',
  package: 'package',
};

const initialFormData = {
  firstName: '',
  middleName: '',
  surname: '',
  email: '',
  serialNumber: '',
  type: '',
  year: '',
  bloodGroup: '',
  gender: '',
  maritalStatus: '',
  motherTongue: '',
  religion: '',
  education: '',
  state: '',
  payment: '',
  reference: '',
  location: '',
  patientReference: '',
  patientStatus: '',
  PatientStatus: '',
  Patient_Type: '',
  status_by_visit: '',
  status_by_treatment: '',
  area: '',
  pincode: '',
  profession: '',
  pic: '',
  mobile: '',
  role: '',
  status: '',
  caseNo: '',
  date: '',
  dateOfBirth: '',
  anniversary: '',
  weight: '',
  height: '',
  diagnosis: {},
  package: '',
  industry: '',
  city: '',
  country: '',
  prescriptions: [],
  primary: '',
  secondary: '',
  tertiary: ''
};

const initialFormError = initialFormData;

export default function CustomerForm() {
  const [formData, setFormData] = useState();
  const [formError, setFormError] = useState(initialFormError);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const { patientId } = useParams();
  const [isProcessing, setIsPorcessing] = useState(false);
  const dispatch = useDispatch();
  const [profile_image_res, set_profile_image_res] = useState('');
  const [selectedCountry, setSelectedCountry] = useState('');
  const [selectedState, setSelectedState] = useState('');
  const [selectedCity, setSelectedCity] = useState('');
  const [filteredStates, setFilteredStates] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);
  const [isSendingLink, setIsSendingLink] = useState(false);

  const handleCopyLink = () => {
    const link = `${window.location.origin}/public/patient/update/${patientId}`;
    navigator.clipboard.writeText(link);
    toast.success('Patient update link copied to clipboard!');
  };

  const handleEmailLink = async () => {
    if (!formData?.email) {
      toast.error('Patient has no email address. Please enter an email and save first.');
      return;
    }
    setIsSendingLink(true);
    try {
      const res = await axios.post(
        `${END_POINT}/public/patient/update/${patientId}/send-link`,
        { origin: window.location.origin, email: formData.email },
        {
          headers: {
            'Content-Type': 'application/json',
            'X-Frontend-Host': window.location.host,
          },
        }
      );
      if (res.data?.success) {
        toast.success(res.data.message || `Update link emailed to ${formData.email}!`);
      }
    } catch (err) {
      toast.error(err?.response?.data?.error || 'Failed to email update link');
    } finally {
      setIsSendingLink(false);
    }
  };

  const countries = countiresData?.countries;
  const states = statesData?.states;
  const cities = citiesData?.cities;


  useEffect(() => {
    if (patientId === 'addNew') {
      setFormData(initialFormData);
    } else {
      fetchSingleItem(patientId).then((e) => {
        setFormData(e?.data);
        let { country, state } = e?.data || {};
        let ctid = countiresData?.countries?.filter((c) => c.name === country)?.[0];
        let stid = statesData?.states?.filter((s) => s.name === state)?.[0];
        setSelectedCountry(ctid?.id);
        setSelectedState(stid?.id);
      });
    }
  }, [patientId]);

  useEffect(() => {
    let filteredStates = states?.filter((st) => Number(st.country_id) === Number(selectedCountry))?.map((e) => e?.name);
    setFilteredStates(filteredStates);
    setFilteredCities(cities?.filter((city) => Number(city?.state_id) === Number(selectedState))?.map((e) => e?.name));
  }, [selectedCountry, selectedState]);

  // handel input change
  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  useEffect(() => {
    dispatch(getSinglePatientFetch(patientId));
  }, [patientId]);

  const handleForm = () => {
    const trimmedFormData = { ...formData };
    let isValidInput = true;

    for (const key in trimmedFormData) {
      if (trimmedFormData?.hasOwnProperty(key)) {
        if (typeof trimmedFormData[key] === 'string') {
          trimmedFormData[key] = trimmedFormData[key].trim();
        }
      }
    }

    let updatedFormError = {};

    if (!trimmedFormData?.mobile) {
      updatedFormError.mobile = 'Phone number is required!';
      isValidInput = false;
    } else if (!/^\d{10}$/.test(trimmedFormData?.mobile)) {
      updatedFormError.mobile = 'Invalid phone number, must be 10 digits!';
      isValidInput = false;
    }

    // validate  first name
    if (!trimmedFormData?.firstName) {
      updatedFormError.firstName = 'First Name is required!';
      isValidInput = false;
    }

    // validate  middle name
    if (!trimmedFormData?.middleName) {
      updatedFormError.middleName = 'Middle Name is required!';
      isValidInput = false;
    }

    // validate sur name
    if (!trimmedFormData?.surname) {
      updatedFormError.surname = 'Surname Name is required!';
      isValidInput = false;
    }

    setFormError(updatedFormError);
    if (!isValidInput) {
      Object.keys(updatedFormError)?.map((f) => {
        toast.error(updatedFormError?.[f]);
      });
    }

    if (isValidInput) {
      setIsPorcessing(true);
      patientId == 'addNew' ? createItem(trimmedFormData, navigate, setIsPorcessing) : updateItem({ ...trimmedFormData, updatedByName: signedInName }, setIsPorcessing);
    }
  };

  const handleProfileUpload = async (e) => {
    let file = e.target.files?.[0];
    if (file) {
      let i = await dispatch(UploadImages([file], formData?._id, 'profile_image', 'customer'));
      if (i == true) {
        set_profile_image_res('Uploaded!!');
      }
    }
  };

  const handleStarRating = (event, rating, name, id) => {
    setFormData({
      ...formData,
      [name]: rating,
    });
  };

  const handleCheckboxChange = (event, name, id) => {
    const { checked } = event.target;
    setFormData({
      ...formData,
      [name]: checked,
    });
  };
  const clinicProfile = useSelector((state) => state?.AdminReducer.clinicProfile);
  const { userLogindata } = useSelector((state) => state.AuthReducer);
  const dropDownData = useSelector((state) => state?.dropDown?.getallDropDowns?.[0] || {});
  const loggedIn = userLogindata?.data;
  const signedInName =
    loggedIn?.name ||
    [loggedIn?.firstName, loggedIn?.surname || loggedIn?.lastName].filter(Boolean).join(' ') ||
    loggedIn?.email ||
    '';

  // Only what the clinic configured on the Drop Down page — no built-in lists.
  const optionsFor = (key) => (Array.isArray(dropDownData?.[key]) ? dropDownData[key] : []);

  // Industry -> profession pairs from the DropDowns page. An industry with no
  // professions of its own keeps offering the full profession list.
  const { parents: industryParents, childrenOf: professionsOf } = useLinkedDropdown('industry');

  const professionFallback = useMemo(() => optionsFor('profession'), [dropDownData?.profession]); // eslint-disable-line react-hooks/exhaustive-deps
  const professionOptions = useMemo(() => {
    const { options } = resolveChildSelection(professionsOf(formData?.industry), professionFallback, formData?.profession);
    return [...new Set([...options, formData?.profession].filter(Boolean))];
  }, [professionsOf, formData?.industry, formData?.profession, professionFallback]);
  const industryOptions = useMemo(() => {
    const base = industryParents.length > 0 ? industryParents : optionsFor('industry');
    return [...new Set([...base, formData?.industry].filter(Boolean))];
  }, [industryParents, dropDownData?.industry, formData?.industry]); // eslint-disable-line react-hooks/exhaustive-deps

  // Choosing an industry pulls its profession along: a lone profession is
  // picked outright, and one left over from the previous industry is dropped.
  const handleIndustryChange = (event) => {
    const industry = event.target.value;
    const profession = resolveChildSelection(professionsOf(industry), professionFallback, formData?.profession).value;
    setFormData((previous) => ({ ...previous, industry, profession }));
  };

  // Status as per visit is stored as status_by_visit (graphs) and mirrored to
  // PatientStatus, which the patient table and prescription page still read.
  const handleVisitStatusChange = (event) => {
    const { value } = event.target;
    setFormData((previous) => ({ ...previous, status_by_visit: value, PatientStatus: value }));
  };

  // Pincode is authoritative for city / state / country, so those are
  // overwritten; area is only filled when empty since a pincode covers many.
  const { onPincodeChange, loading: pincodeLoading, error: pincodeError } = usePincodeLookup(
    useCallback((details) => {
      setFormData((previous) => ({
        ...previous,
        country: details.country || previous?.country || '',
        state: details.state || previous?.state || '',
        city: details.city || previous?.city || '',
        area: previous?.area || details.area || '',
      }));
      const ct = countiresData?.countries?.find((c) => c.name?.toLowerCase() === String(details.country || '').toLowerCase());
      const st = statesData?.states?.find((x) => x.name?.toLowerCase() === String(details.state || '').toLowerCase());
      if (ct) setSelectedCountry(ct.id);
      if (st) setSelectedState(st.id);
    }, [])
  );

  const handlePincodeChange = (event) => {
    handleInputChange(event);
    onPincodeChange(event.target.value);
  };

  // Props shared by every dropdown-store backed select.
  const dropdownProps = (key, extra = {}) => {
    const field = PATIENT_DROPDOWN_FIELDS[key];
    return {
      onChange: handleInputChange,
      name: field,
      value: formData?.[field],
      error: formError?.[field],
      options: optionsFor(key),
      placeholder: SELECT_PLACEHOLDER,
      emptyText: NO_OPTIONS_HINT,
      ...extra,
    };
  };

  useEffect(() => {
    dispatch(setClinicProfile());
    dispatch(getAllDropDowns());
    dispatch(getAllAilments());
  }, []);

  const completion = getProfileCompletion(formData);
  const completionBarColor =
    completion.percent >= 80 ? 'bg-emerald-500' : completion.percent >= 50 ? 'bg-amber-500' : 'bg-rose-500';


  return (
    <RightWrapper>
      <div className="w-full py-6">
        {/* Main container */}
        <div className="w-full px-2 py-6">

          {/* Top Header */}
          <div className="flex items-center gap-3 pb-4 border-b">
            {clinicProfile?.imageData && (
              <img
                className="w-9 h-9 rounded-full object-cover"
                src={`data:image/jpeg;base64,${clinicProfile?.imageData}`}
                alt="Clinic"
              />
            )}

            <h1 className="text-xl font-semibold text-gray-900">
              {window.location.hostname === "shivenclinic.com"
                ? "Shiven Clinic Management"
                : clinicProfile?.data?.ClinicName || "LocalClinic"}
            </h1>
          </div>

          {/* Patient data completeness — kept at the very top so staff can see
              at a glance how much of the record is still empty. */}
          {formData && (
            <div className="mt-4 rounded-xl border border-gray-200 bg-white p-4 shadow-[0_4px_16px_rgba(0,0,0,0.05)]">
              <div className="flex items-center justify-between gap-3">
                <span className="text-sm font-semibold text-gray-800">Patient Data Completion</span>
                <span className="text-sm font-bold text-gray-900">
                  {completion.percent}%
                  <span className="ml-2 text-xs font-medium text-gray-500">
                    ({completion.filled}/{completion.total} fields)
                  </span>
                </span>
              </div>

              <div className="mt-2 h-2.5 w-full overflow-hidden rounded-full bg-gray-200">
                <div
                  className={`h-full rounded-full transition-all duration-500 ${completionBarColor}`}
                  style={{ width: `${completion.percent}%` }}
                />
              </div>

              {completion.missing.length > 0 && (
                <p className="mt-2 text-xs text-gray-500">
                  Missing: {completion.missing.map((f) => COMPLETION_FIELD_LABELS[f] || f).join(', ')}
                </p>
              )}
            </div>
          )}

          {/* Navigation */}
          <div className="flex flex-wrap justify-between items-center mt-4 mb-2 gap-2">
            <button
              onClick={() => navigate(-1)}
              className="
          px-4 py-2 rounded-md text-sm font-medium
          bg-gray-100 text-gray-700
          hover:bg-gray-200 transition
        "
            >
              ← Back
            </button>

            <div className="flex items-center flex-wrap gap-2">
              {patientId && patientId !== 'addNew' && (
                <>
                  <button
                    type="button"
                    onClick={handleCopyLink}
                    title="Copy public link to share with patient"
                    className="
                      flex items-center gap-1.5 px-3 py-2 rounded-md text-xs font-medium
                      bg-sky-50 text-sky-700 border border-sky-200
                      hover:bg-sky-100 transition cursor-pointer shadow-2xs
                    "
                  >
                    <FiCopy className="w-3.5 h-3.5" />
                    Copy Update Link
                  </button>

                  <button
                    type="button"
                    onClick={handleEmailLink}
                    disabled={isSendingLink}
                    title="Email public update link to patient"
                    className="
                      flex items-center gap-1.5 px-3 py-2 rounded-md text-xs font-medium
                      bg-sky-600 text-white
                      hover:bg-sky-700 transition cursor-pointer disabled:opacity-60 shadow-2xs
                    "
                  >
                    <FiSend className="w-3.5 h-3.5" />
                    {isSendingLink ? 'Sending...' : 'Email Link to Patient'}
                  </button>

                  <a
                    href={`/public/patient/update/${patientId}`}
                    target="_blank"
                    rel="noreferrer"
                    title="Open patient update portal in new tab"
                    className="
                      flex items-center gap-1 px-2.5 py-2 rounded-md text-xs font-medium
                      bg-slate-100 text-slate-700 border border-slate-200
                      hover:bg-slate-200 transition shadow-2xs
                    "
                  >
                    <FiExternalLink className="w-3.5 h-3.5" />
                  </a>
                </>
              )}

              <Link to="reports">
                <button
                  className="
              px-4 py-2 rounded-md text-sm font-medium
              bg-amber-100 text-amber-700
              hover:bg-amber-200 transition
            "
                >
                  Reports
                </button>
              </Link>
            </div>
          </div>

          {formData !== null ? (
            <div className="space-y-10 bg-white rounded-xl border border-gray-200 shadow-[0_8px_28px_rgba(0,0,0,0.06)] p-8">

              <section className="">
                <h2 className="flex items-center gap-2 text-lg font-semibold text-gray-800 border-l-4 border-primary-500 pl-3 mb-6">
  Personal Information
</h2>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-5">
                  <CustomInput onChange={handleInputChange} label="First Name" value={formData?.firstName} error={formError?.firstName} name="firstName" placeholder="Enter First Name" />
                  <CustomInput onChange={handleInputChange} label="Middle Name" value={formData?.middleName} error={formError?.middleName} name="middleName" />
                  <CustomInput onChange={handleInputChange} label="Last Name" value={formData?.surname} error={formError?.surname} name="surname" />
                  <CustomInput onChange={handleInputChange} label="Email" value={formData?.email} error={formError?.email} name="email" />
                  <CustomInput onChange={handleInputChange} label="Contact Number" type="number" value={formData?.mobile} error={formError?.mobile} name="mobile" />

                  <CustomSelect
                    label="Country"
                    name="country"
                    value={formData?.country}
                    error={formError?.country}
                    options={countries?.map(c => c.name)}
                    onChange={(e) => {
                      handleInputChange(e);
                      const c = countries.find(x => x.name === e.target.value);
                      setSelectedCountry(c?.id);
                    }}
                    placeholder={SELECT_PLACEHOLDER}
                  />

                  <CustomSelect
                    label="State"
                    name="state"
                    value={formData?.state}
                    error={formError?.state}
                    options={filteredStates}
                    onChange={(e) => {
                      handleInputChange(e);
                      const s = states.find(x => x.name === e.target.value);
                      setSelectedState(s?.id);
                    }}
                    placeholder={SELECT_PLACEHOLDER}
                  />

                  <CustomSelect label="City" name="city" value={formData?.city} error={formError?.city} options={filteredCities} onChange={handleInputChange} placeholder={SELECT_PLACEHOLDER} />

                  <CustomInput onChange={handleInputChange} label="Area" value={formData?.area} error={formError?.area} name="area" />
                  <CustomInput onChange={handleInputChange} label="Address" value={formData?.location} error={formError?.location} name="location" />
                  <div>
                    <CustomInput onChange={handlePincodeChange} label="Pincode" type="number" value={formData?.pincode} error={formError?.pincode} name="pincode" />
                    {pincodeLoading && <p className="mt-1 text-xs text-gray-500">Looking up…</p>}
                    {!pincodeLoading && pincodeError && <p className="mt-1 text-xs text-amber-600">{pincodeError}</p>}
                  </div>

                  <CustomSelect label="Education" {...dropdownProps('education')} />
                  <div>
                    <SearchableSelect onChange={handleIndustryChange} label="Industry" name="industry" value={formData?.industry} error={formError?.industry} options={industryOptions} placeholder={SELECT_PLACEHOLDER} />
                    {industryOptions.length === 0 && <p className="mt-1 text-xs text-gray-500">{NO_OPTIONS_HINT}</p>}
                  </div>

                  <div>
                    <SearchableSelect onChange={handleInputChange} label="Profession" name="profession" value={formData?.profession} error={formError?.profession} options={professionOptions} placeholder={SELECT_PLACEHOLDER} />
                    {professionOptions.length === 0 && <p className="mt-1 text-xs text-gray-500">{NO_OPTIONS_HINT}</p>}
                  </div>
                  <CustomSelect label="Type of Patient" {...dropdownProps('type_of_patient')} />
                  <CustomSelect
                    label="Status as per Visit"
                    {...dropdownProps('status_by_appointment', {
                      onChange: handleVisitStatusChange,
                      value: formData?.status_by_visit || formData?.PatientStatus || formData?.patientStatus,
                    })}
                  />
                  <CustomSelect label="Status as per Treatment" {...dropdownProps('status_by_treatment')} />
                  <CustomSelect label="Package" {...dropdownProps('package')} />

                  <CustomSelect label="Reference" {...dropdownProps('reference_for_enquiry')} />

                  {String(formData?.reference ?? '').trim().toLowerCase() === 'patient' && (
                    <CustomSelect
                      label="Patient Reference"
                      {...dropdownProps('patient_reference', {
                        value: formData?.patientReference || formData?.patient_reference,
                      })}
                    />
                  )}

                  <CustomSelect label="Mother Tongue" {...dropdownProps('mother_tongue')} />
                  <CustomSelect label="Religion" {...dropdownProps('religion')} />
                  <CustomSelect label="Gender" {...dropdownProps('gender')} />
                  <CustomInput onChange={handleInputChange} label="Date of Birth" type="date" name="dateOfBirth" value={formData?.dateOfBirth} error={formError?.dateOfBirth} />
                  <CustomSelect label="Marital Status" {...dropdownProps('marital_status')} />
                  <CustomInput onChange={handleInputChange} label="Anniversary" type="date" name="anniversary" value={formData?.anniversary} error={formError?.anniversary} />

                  <CustomImageInput label="Profile Image" onChange={handleProfileUpload} res={profile_image_res} exist_profile={formData?.profile_image?.[0]} />
                </div>
              </section>

              {/* ===================== Medical Information ===================== */}
              {/* Blood group is asked on add too; weight/height stay edit-only. */}
              <section className="bg-white rounded-xl border border-gray-200
shadow-[0_6px_24px_rgba(0,0,0,0.06)]">
                <h2 className="text-lg font-semibold text-gray-800 border-l-4 border-primary-400 pl-3 mb-6">
                  Medical Information
                </h2>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-5">
                  <CustomSelect label="Blood Group" {...dropdownProps('blood_group')} />
                  {formData?._id && (
                    <>
                      <CustomInput onChange={handleInputChange} label="Weight (KG)" type="number" name="weight" value={formData?.weight} error={formError?.weight} />
                      <CustomInput onChange={handleInputChange} label="Height (cm)" type="number" name="height" value={formData?.height} error={formError?.height} />
                    </>
                  )}
                </div>
              </section>

              {/* ===================== Submit ===================== */}
              <div className="max-w-sm mx-auto pt-4">
                <CustomButton
                  onClick={handleForm}
                  isProcessing={isProcessing}
                  label={patientId === 'addNew' ? 'Submit' : 'Save'}
                />
              </div>
            </div>
          ) : (
            <CustomSpinner />
          )}
        </div>
      </div>
    </RightWrapper>

  );
}

export const ChildrenComponent = ({ id, label, formData, uploadType, SectionType }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch();
  const [showImage, setShowImages] = useState(false);

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleImageCloseModal = () => {
    setShowImages(false);
  };

  const handleFileUpload = (file) => {
    if (file) {
      setIsModalOpen(false);
      dispatch(UploadFile(file, formData?._id, uploadType, SectionType));
    }
  };

  const handleMutlipleFileUploads = (file) => {
    if (file) {
      setIsModalOpen(false);

      dispatch(UploadFiles(file, formData?._id, uploadType, SectionType));
    }
  };

  const handleImageUpload = async (file) => {
    if (file) {
      setIsModalOpen(false);
      let res = await dispatch(UploadImages(file, formData?._id, uploadType, SectionType));
      if (res === true) {
        toast.success('Images uploaded');
      }
    }
  };

  return (
    <div className="ChildernMain flex flex-col gap-2">
      <h4 className="font-semibold">{label}</h4>
      <label className="text-xs p-0 m-0 " htmlFor="">
        {uploadType !== 'pictures' ? uploadType !== 'externalUploads' && (formData?.[uploadType] ? '1 File' : 'No File Uploaded') : `${formData?.[uploadType]?.length} image uploded`}
        {uploadType == 'externalUploads' && `${formData?.[uploadType]?.length || 'No'} files uploaded`}
      </label>
      {uploadType == 'externalUploads' && (
        <div className="flex flex-col bg-white p-2 h-[10vh] overflow-y-scroll gap-2">
          {formData?.[uploadType]?.map((file) => (
            <a className="text-blue-700 font-bold" target="_blank" href={`${END_POINT}/customer/get/${file?.id}`}>
              {file?.name}
            </a>
          ))}
        </div>
      )}
      <div className="pChilldrenControls flex gap-5">
        <button className="border p-2 py-1 rounded rounded-md bg-neutral-400" onClick={() => setIsModalOpen(uploadType)}>
          <p className="text-xs font-semibold text-white">UPLOAD</p>
        </button>
        <button className="border p-2 py-1 rounded rounded-md bg-neutral-400">
          <p
            className="text-xs font-semibold text-white"
            onClick={() => {
              !['pictures', 'externalUploads'].includes(uploadType) ? dispatch(RemoveFile(formData?.[uploadType], formData?._id, uploadType, 'customer')) : dispatch(DeleteImages({ fileIds: uploadType == 'externalUploads' ? formData?.[uploadType]?.map((i) => i?.id) : formData?.[uploadType] }, formData?._id, 'customer', uploadType));
            }}
          >
            DELETE
          </p>
        </button>
        {formData?.[uploadType] && (
          <button className="border p-2 py-1 rounded rounded-md bg-neutral-400">
            <p
              className="text-xs font-semibold text-white"
              onClick={(e) => {
                uploadType !== 'pictures' ? window.open(`${END_POINT}/customer/get/${formData?.[uploadType]}`) : setShowImages(true);
              }}
            >
              VIEW
            </p>
          </button>
        )}
      </div>

      {isModalOpen !== 'pictures' ? uploadType !== 'externalUploads' && <FileUploadModal isOpen={isModalOpen} closeModal={handleCloseModal} onFileUpload={handleFileUpload} uploadType={uploadType} /> : <ImageUploadModal isOpen={isModalOpen} closeModal={handleCloseModal} onImageUpload={handleImageUpload} />}
      {showImage == true && <ImageShowModal isOpen={showImage} closeModal={handleImageCloseModal} Images={formData?.[uploadType]} />}
      {isModalOpen == 'externalUploads' && <MultipleFileUploads isOpen={isModalOpen} closeModal={handleCloseModal} onFileUpload={handleMutlipleFileUploads} uploadType={uploadType} />}
    </div>
  );
};
